import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Cascader } from 'antd';
import Icon from '../Icon';
import View from '../View';
import Result from '../Result';

const CascaderStyled = styled(Cascader)`
  width: 600px !important;
  max-width: 100%;
  ${(props) => props.error && css`
    border-color: red;
    border-width: 1px;
    border-style: solid;
  `}
`;

const ErrorIcon = styled(Icon.CloseOutlined)`
  color: red;
`;

const getSuffixIcon = (loading, error, suffixIcon) => {
  if (error) return <ErrorIcon />;
  if (loading) return <Icon.LoadingOutlined />;

  return suffixIcon;
};

const getNotFoundContent = (error, notFoundContent) => {
  return (error) ? (
    <Result
      status="error"
      title="Erro ao buscar dados"
      subTitle={error.message}
      icon={<View />}
    />
  ) : notFoundContent;
};

const CascaderComponent = ({ options: optionsCascader, action, suffixIcon, notFoundContent, disabled, ...otherProps }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [options, setOptions] = useState(optionsCascader);

  useEffect(() => {
    const fetchData = async () => {
      return action().then((res) => {
        setLoading(false);
        setOptions(res);
      }).catch((err) => {
        setLoading(false);
        setError(err);
      });
    };

    if (action) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [action]);

  return (
    <CascaderStyled
      allowClear
      showSearch
      expandTrigger="hover"
      options={options}
      suffixIcon={getSuffixIcon(loading, error, suffixIcon)}
      notFoundContent={getNotFoundContent(error, notFoundContent)}
      error={error}
      disabled={(loading) ? true : disabled}
      {...otherProps}
    />
  );
};

CascaderComponent.propTypes = {
  action: PropTypes.func,
  disabled: PropTypes.bool,
  notFoundContent: PropTypes.node,
  options: PropTypes.array,
  suffixIcon: PropTypes.node,
};

export default CascaderComponent;
